import { useState } from 'react'

function useSelectList<
    T = {
        [key: string]: any
    }
>(defaultVal: T[] = [], key: string) {
    const [select, setSelect] = useState<T[]>(defaultVal)

    const remove = (val: T) => {
        setSelect(l => {
            const temp = [...l]
            const index = (value: T) => {
                // @ts-ignore
                return l.findIndex(v => v[key] === value[key])
            }
            temp.splice(index(val), 1)

            return temp
        })
    }

    const add = (val: T) => setSelect(l => [...l, val])

    const has = (val: T) => {
        // @ts-ignore
        return select.findIndex(v => v[key] === val[key]) !== -1
    }

    const toggle = (val: T) => {
        // @ts-ignore
        has(val) ? remove(val) : add(val as T)
    }

    return {
        has,
        add,
        remove,
        select,
        setSelect,
        toggle,
    }
}

export default useSelectList
